import React from 'react';
import logoImage from '../assets/images/safa_energy_logo_gray_img.png'
import Lottie from "lottie-react";
import successAnimation from "../assets/lottie/success_icon.json"; // Adjust the path if needed
export default function SuccessScreen(){
    return (<>
    <div className="px-6 lg:py-10 py-4">

  
       <img className="lg:w-64 md:w-52 w-32 py-4  mx-auto" src={logoImage}/>
      
       <div className="flex justify-center items-center">
        <Lottie animationData={successAnimation} className="lg:w-36 md:w-32 w-28" loop={true} />
      </div>
<p className='md:py-4 py-2 px-6 text-center lg:text-lg md:text-base text-sm  font-semibold text-black'>Your response has been submitted successfully. Our team will connect with you shortly.</p>
        </div>
        </>)
}